<template>
  <canvas :ref="`qrCodeCanvas${num}`" :class="`qrCode${num}`"></canvas>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'QrCodeComponent',
  props: {
    // 二维码内容
    value: {
      type: String,
      default: 'https://uqrcode.cn/doc',
    },
    canvasWidth: {
      default: 200,
      type: Number
    },
    canvasHeight: {
      default: 200,
      type: Number
    },
  },
  data() {
    return {
      // 生成唯一标识符
      num: Math.random().toString(36).substr(2, 9),
    };
  },
  watch: {
    value: {
      handler() {
        this.getQRCode();
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getQRCode();
    });
  },
  methods: {
    getQRCode() {
      const canvas = this.$refs[`qrCodeCanvas${this.num}`];

      if (!canvas || !canvas.getContext) {
        console.error('Canvas 元素获取失败');
        return;
      }

      QRCode.toCanvas(canvas, this.value, {
        width: this.canvasWidth,
        height: this.canvasHeight,
        color: {dark: '#000', light: '#fff'},
        errorCorrectionLevel: 'H',
      }, (error) => {
        if (error) {
          console.error('生成二维码失败', error);
        } else {
          console.log('二维码生成成功');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.qrCode {
  display: block;
}
</style>
